import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import AuthLayout from "../../Components/Layouts/Authlayout";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { InputType, handleApiErrors, validationRegex } from "../../Utils/Utils";
import CustomTextField from "../../Components/Reusable/CustomTextField";
// import AuthService from "../../Services/AuthService";
import Image from "../../Components/Reusable/Image";
import { OtpVerificationType } from "../../Utils/Enums";
import RoutesPath from "../../Utils/RoutesPath";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import { SubTitleLabel, TitleLabel } from "../../Components/Reusable/LabelComponents";
import SubmitButtonTwo from "../../Components/Reusable/Buttontwo";
import CustomTextFieldTwo from "../../Components/Reusable/CustomTextFieldTwo";
import StudentDashboardServices from "../../Services/StudentDashboardApiService";
import CoAuthLayout from "../../Components/Layouts/CoAuthlayout";
import CoordinatorApiServices from "../../Services/CoordinatorApiServices";
import SessionManager from "../../Utils/Session";
import { RotatingLines } from "react-loader-spinner";
import BharatSatExAuthLayout from "../../Components/Layouts/BharatSatExAuthLayout";
import { Modal } from "react-bootstrap";
import { AuthContext } from "../../Context/authContext";
import { toast } from "react-toastify";

const BharatSatExamLogin = () => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext)
  const [examId, setExamId] = useState("");
  const [loading, setLoading] = useState(false)
  const [mockTestData, setMockTestData] = useState([]);
  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  const [token, setToken] = useState('');
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const validationSchema = Yup.object().shape({
    email: validationRegex.email,
    password: validationRegex.required
  });

  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(validationSchema),
  });
  useEffect(() => {
    if (user.bharatSatExamId) {
      setExamId(user.bharatSatExamId)
    }
  }, [user, user.bharatSatExamId])

  const onSubmit = async (data) => {
    setLoading(true)

    const { email, password } = data;
    try {
      const response = await StudentDashboardServices.login(email, password);
      if (response.status === 201) {
        handleShow();
        setData(response.data.data);
        setToken(response.data.token);
        setLoading(false);
      } else {
        SessionManager.shared.deleteCoordinatorToken();       
        navigate(`${RoutesPath.bharatSatTest}/${response.bharatSatExamId}`);
      }
      // setShow(true);
    } catch (error) {
      setLoading(false);
      handleApiErrors(error);
    }
  };


  // const handleClose = () => {
  //   setShow(false);
  //   setLoading(false)
  // };
  const handleStartTest = () => {
    navigate(`${RoutesPath.bharatSatTest}/${examId}`);
  };
  const instructions = [
    "Camera Visibility: Ensure your camera is on and you are clearly visible from head to chest throughout the examination.",
    "Fair Play: Maintain academic integrity. Do not engage in any form of cheating or malpractice.",
    "No Communication: Refrain from communicating with anyone during the examination.",
    "No External Assistance: Do not seek help from any external source, including textbooks, notes, or online resources.",
    "Time Management: The examination duration is 90 minutes. Allocate time wisely to answer all questions.",
    "Question Format: The examination consists of 100 Multiple Choice Questions (MCQs).",
    "Marking Scheme: Each correct answer carries 2 marks.",
    "Submission Deadline: The examination will be automatically submitted after 90 minutes. Ensure you submit your answers before the deadline.",
    "Result Implications: Any violation of the examination rules may lead to the cancellation of your result.",
    "The merit list will be prepared based on the marks obtained by the student and the time they took to complete the test.",
    "Each incorrect answer will result in a deduction of 0.5 marks from your total score. Please be mindful of this when answering the questions.",
  ];
  const handleLogout = async (token) => {
    // console.log(token, 'token');
    try {
      const response = await StudentDashboardServices.logoutDevices(token);
      toast.success(response.message)
      handleClose();
      setLoading(false);
      document.getElementById("login_btn").click();
    } catch (error) {
      setLoading(false);
      handleApiErrors(error)
    }
  };
  return (
    <BharatSatExAuthLayout>
      <div className="col-md-7 m-auto">
        <div className="d-flex justify-content-center login_logo">
          {/* <Image src={PngImages.logo} alt="Logo" /> */}
          <Image src={SvgImages.logo} className="img-fluid" style={{ height: "70px" }} />
        </div>

        <div className="mb-4 text-center">
          <TitleLabel text={"Welcome Back!"} />
          <SubTitleLabel text={"Enter your Credentials to access your account"} />
        </div>

        <form className="position-relative" onSubmit={handleSubmit(onSubmit)} >
          <CustomTextFieldTwo
            labelTitle="Email Id"
            additionalClasses="profile_input"
            icon={SvgImages.email}
            id="email"
            name="email"
            placeholder="Enter your email id"
            showError={errors?.email}
            errorMessage={errors?.email?.message}
            register={register}
          />

          <CustomTextFieldTwo
            labelTitle="Password"
            additionalClasses="profile_input"
            icon={SvgImages.lock}
            id="password"
            name="password"
            inputType={InputType.password}
            placeholder="Enter your password"
            showError={errors?.password}
            errorMessage={errors?.password?.message}
            register={register}
            imageClass="input-lock-icon"
          />

          <Link to={RoutesPath.bharatsatexamforgotpassword}>
            <h4 className="forgot mb-4 right_menu_toggle">Forgot password?</h4>
          </Link>

          {loading ? (
            <div className="text-center d-flex justify-content-center">
              <RotatingLines
                height="25"
                width="25"
                strokeColor="#F6821F"
                ariaLabel="bars-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
            </div>
          ) : (
            <SubmitButtonTwo id={"login_btn"} title={"Login"} className='w-100 fw-700' />
          )}


        </form>
        <Modal
          show={show}
          onHide={handleClose}
          size="lg
              "
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={false}
          contentClassName="rounded-5"
        >
          <div
            className="modal-header px-5 my-2 medium-text fs-5 fw-600 justify-content-end d-flex"
            style={{ borderBottom: "none" }}
          >
            <Image
              className="cursor-pointer"
              src={PngImages.redcross}
              style={{ aspectRatio: 1 }}
              onClick={handleClose}
            />
          </div>

          <div className="border m-4 mt-0
               ">
            <div
              className="d-flex justify-content-center mb-3 align-items-center px-3 py-2"
              id="contained-modal-title-vcenter"
              style={{ backgroundColor: "#EFF5FF" }}
            >
              <h2 className="Heading blue text-center fw-600">
                Multiple Device Login
              </h2>
            </div>

            <Modal.Body className="pb-4">
              <div className="row container-fluid ">
                <div className="col-lg-5">
                  <Image
                    className="card-img-top"
                    src={PngImages.multiple_device}
                  />
                </div>
                <div className="col-lg-7">
                  <div className="">
                    <div className="mb-5 medium-text fw-600">
                      <p className="medium-text fw-600 ">
                        You are logged in on another
                        device. Do you want to continue
                        on this device?
                      </p>

                      <div className="blue d-flex gap-2 cursor-pointer">
                        {
                          data.map((item, index) => {
                            return (
                              <div key={index} className="text-capitalize">
                                [
                                {
                                  item.deviceType === 'mobile' ? <MdPhoneAndroid /> : <Image
                                    className="card-img-top mx-2"
                                    src={item.deviceType == 'mobile' ? <MdPhoneAndroid /> : PngImages.chrome_windows}
                                    style={{ width: "5%" }}
                                  />
                                }
                                {item.browser + " on " + item.deviceName}&nbsp;
                                ]
                              </div>
                            )
                          })
                        }
                        {/* [
                        <Image
                          className="card-img-top"
                          src={PngImages.chrome_windows}
                          style={{ width: "5%" }}
                        />Chrome on Windows
                        ] */}
                      </div>


                    </div>
                    <SubmitButtonTwo
                      title={'Log out from other device'}
                      className="addtocardbtn w-75"
                      onclick={() => handleLogout(token)}
                    />
                  </div>
                </div>


              </div>
            </Modal.Body>
          </div>
        </Modal>
        {/* <Modal
          show={show}
          onHide={handleClose}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          contentClassName="rounded-5"
        >
          <div className="border m-5">
            <div
              className="d-flex justify-content-between mb-3 align-items-center px-3 py-2"
              id="contained-modal-title-vcenter"
              style={{ backgroundColor: "#EFF5FF" }}
            >
              <h2 className="Heading headingColor text-center fw-600">
                Instructions:
              </h2>
              <div className="medium-text fw-500 text-danger fst-italic">
                Please read the instructions carefully before starting the test.
              </div>
            </div>

            <Modal.Body>
              <div className="container-fluid ps-4">
                {instructions.map((instruction, index) => (
                  <div key={index} className="mb-4">
                    <div className="mb-2 medium-text fw-600 d-flex">
                      <span className="fst-italic">{index + 1}. &nbsp;</span>
                      <em className="medium-text fw-400">{instruction}</em>
                    </div>
                  </div>
                ))}
              </div>
            </Modal.Body>
            <Modal.Footer className="text-center border-0 d-flex justify-content-center">
              <div>

                <SubmitButtonTwo
                  title={"Start Test"}
                  className="start-test-btn"
                  onclick={handleStartTest}
                />

              </div>
            </Modal.Footer>
          </div>
        </Modal> */}
      </div>
    </BharatSatExAuthLayout>
  );
};

export default BharatSatExamLogin;

